import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-itemError",
  "use": "icon-itemError-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-itemError\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 512a512 512 0 1 0 1024 0A512 512 0 1 0 0 512z\" fill=\"#EC4141\" p-id=\"2134\" /><path d=\"M849.92 580.267H174.08c-30.72 0-54.613-23.894-54.613-54.614s23.893-54.613 54.613-54.613h675.84c30.72 0 54.613 23.893 54.613 54.613s-23.893 54.614-54.613 54.614z\" fill=\"#FFFFFF\" p-id=\"2135\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/itemError.svg
// module id = LYbj
// module chunks = 132